export default __webpack_public_path__ + "static/media/updatePassword.3aa31a21.png";